import React from 'react';
import { connect } from 'react-redux';

import { updateQueryString } from 'services/router/actions';
import './styles.scss';

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
}

type Props = DispatchProps;

class CreateGroupButton extends React.PureComponent<Props> {
    handleClick = (): void => {
        this.props.updateQueryString({
            groupModal: true,
            selectedGroup: undefined
        });
    };

    render(): React.ReactElement {
        return (
            <div className="event-create-group-button-container">
                <button
                    onClick={this.handleClick}
                    className="event-create-group-button"
                    type="button"
                >
                    + Create new group
                </button>
            </div>
        );
    }
}

export default connect(
    null,
    { updateQueryString }
)(CreateGroupButton);
